<template>
  <div class="module-info-container">
    <div class="card-header">
      <FriedH4>{{ $t('plans_information_full_experience_title') }}</FriedH4>
      <FriedParagraph>
        {{ $t('plans_information_full_experience_description') }}
      </FriedParagraph>
    </div>
    <div class="compare-plans-container">
      <div class="plan-container">
        <div class="plan-info">
          <FriedH3 class="plan-header">{{ t('professional-plan') }}</FriedH3>
          <FriedParagraph size="small">
            {{ $t('plans_information_professional_description') }}
          </FriedParagraph>
        </div>
        <IncludedFeatures :check-list="professionalChecklist" />
      </div>
      <div class="plan-container">
        <div class="plan-info">
          <FriedH3 class="plan-header">{{ t('enterprise-plan') }}</FriedH3>
          <FriedParagraph size="small">
            {{ $t('plans_information_enterprise_description') }}
          </FriedParagraph>
        </div>
        <IncludedFeatures :check-list="enterpriseChecklist" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { computed } from 'vue';
import IncludedFeatures from './IncludedFeatures.vue';

const professionalChecklist = computed(() => [
  t('plans_information_professional_unlimited_rooms'),
  t('plans_information_professional_unlimited_esign'),
  t('plans_information_professional_product_pricing'),
  t('plans_information_professional_tracking'),
  t('plans_information_professional_integrations'),
]);

const enterpriseChecklist = computed(() => [
  t('plans_information_enterprise_everything'),
  t('plans_information_enterprise_cpq'),
  t('plans_information_enterprise_contract_management'),
  t('plans_information_enterprise_sso'),
  t('plans_information_enterprise_integrations'),
]);
</script>

<style lang="scss" scoped>
@import '../scss/colors';

.module-info-container {
  padding: var(--spacing-150) var(--spacing-100);
  background: var(--gray-98);
  border-radius: var(--radius-medium);

  .card-header {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-50);
    padding-bottom: var(--spacing-200);
  }

  .compare-plans-container {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-150);

    @media only screen and (min-width: $xs) {
      flex-direction: row;
    }

    .plan-container {
      background: var(--white);
      border-radius: var(--radius-medium);
      padding: var(--spacing-150);

      @media only screen and (min-width: $xs) {
        width: 50%;
      }

      .plan-info {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-50);
        margin-bottom: var(--spacing-150);

        .plan-header {
          color: $dark-purple;
        }
      }
    }
  }
}
</style>
